import React from 'react';
import { observer } from 'mobx-react-lite';
import { toTextQuestionAnswer } from '../../stores/QuestionStore';
import { DisplayMode } from '../RenderForm';
import { EditNumber } from './edit/EditNumber';
import { ViewNumber } from './view/ViewNumber';
export var Number = observer(function (_ref) {
  var _questionStore$formQu4;
  var id = _ref.id,
    errorId = _ref.errorId,
    questionStore = _ref.questionStore,
    displayMode = _ref.displayMode;
  var showEditComponent = displayMode === DisplayMode.Edit;
  if (showEditComponent) {
    var _questionStore$formQu, _questionStore$formQu2, _questionStore$formQu3;
    return /*#__PURE__*/React.createElement(EditNumber, {
      id: id,
      errorId: errorId,
      value: toTextQuestionAnswer(questionStore.currentAnswer),
      isInvalid: !!questionStore.validationErrors,
      isRequired: (_questionStore$formQu = questionStore.formQuestion) === null || _questionStore$formQu === void 0 || (_questionStore$formQu = _questionStore$formQu.validation) === null || _questionStore$formQu === void 0 ? void 0 : _questionStore$formQu.rq,
      onChange: function onChange(event) {
        var value = event.target.value.trim().replace(/[^\d.\-,]/g, '');
        questionStore.setAnswer(value);
      },
      label: (_questionStore$formQu2 = questionStore.formQuestion) === null || _questionStore$formQu2 === void 0 ? void 0 : _questionStore$formQu2.label,
      jiraField: (_questionStore$formQu3 = questionStore.formQuestion) === null || _questionStore$formQu3 === void 0 ? void 0 : _questionStore$formQu3.jiraField
    });
  }
  return /*#__PURE__*/React.createElement(ViewNumber, {
    id: id,
    value: toTextQuestionAnswer(questionStore.currentAnswer),
    displayMode: displayMode,
    jiraField: (_questionStore$formQu4 = questionStore.formQuestion) === null || _questionStore$formQu4 === void 0 ? void 0 : _questionStore$formQu4.jiraField
  });
});